import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';
import { store, useAppSelector } from './store';
import App from './App';
import './i18n';

const ThemedApp: React.FC = () => {
  const mode = useAppSelector((state) => state.theme);
  const theme = React.useMemo(() =>
    createTheme({
      palette: {
        mode,
        primary: {
          main: '#4facfe',
        },
        secondary: {
          main: '#00f2fe',
        },
        background: {
          default: mode === 'dark' ? '#121212' : '#f5f5f5',
          paper: mode === 'dark' ? '#1e1e1e' : '#fff',
        },
      },
      shape: {
        borderRadius: 12,
      },
    }), [mode]);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemedApp />
    </Provider>
  </React.StrictMode>
); 